import { fetchPlansIfNeeded, plansSelector } from '../../plans';
import { connect } from 'react-redux';
import { InsurancePlanDropdownContainer } from './InsurancePlanDropdownContainer';

export function mapStateToProps(state, props) {
    const plans = plansSelector(state, props.carrierId);

    if (!plans || plans.length === 0) {
        return {
            isLoading: true,
            plans: [],
        };
    }

    return {
        isLoading: false,
        plans,
    };
}

export const mapDispatchToProps = {
    fetchPlansIfNeeded,
};

export const InsurancePlanDropdownConnector = connect(
    mapStateToProps,
    mapDispatchToProps
)(InsurancePlanDropdownContainer);
